<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useRoot } from '~/store'
import { Iconify } from '~/types/assets'
import { useRadar } from '~/store/radar'
import { useLocaleThemePath } from '~/composables/locale'

const page = '_cert'

const $radar = useRadar()
const { setWheelsCount } = useRoot()
const i18nHead = useLocaleHead()
const { t } = useI18n()

const { routeRaw } = storeToRefs($radar)

const certSlug = routeRaw.value?.params?.cert as string

$radar.setPreviousRoutePath('/certs')

useSeoMeta({
  title: () => t(`routes.${page}.title`, { name: certSlug }),
  ogTitle: () => t(`routes.${page}.title`, { name: certSlug }),
  description: () => t(`routes.${page}.description`, { name: certSlug }),
  ogDescription: () => t(`routes.${page}.description`, { name: certSlug })
})

useHead(i18nHead.value)

useStructuredData(page)

const location = computed(
  () =>
    ({
      boolean: 'https://s3.rottigni.tech/public/documents/certifications/boolean_certification.pdf',
      'python-for-data-science-and-machine-learning-bootcamp':
        'https://s3.rottigni.tech/public/documents/certifications/UC-88f3c885-4827-43be-83d9-9d594b9a9c5b.pdf',
      'python-for-natural-language-processing':
        'https://s3.rottigni.tech/public/documents/certifications/NLP_udemy_course.webp',
      ccna: 'https://s3.rottigni.tech/public/documents/certifications/CCNA_certification.pdf',
      ite: 'https://s3.rottigni.tech/public/documents/certifications/ITE_certification.pdf',
      'ccna-letter': 'https://s3.rottigni.tech/public/documents/certifications/CCNA_letter.pdf',
      'cisco-stage': 'https://s3.rottigni.tech/public/documents/certifications/cisco_stage.pdf',
      'k8s-mastery': 'https://s3.rottigni.tech/public/documents/certifications/K8s_mastery.webp',
      'python-for-computer-vision':
        'https://s3.rottigni.tech/public/documents/certifications/computer_vision_udemy_course.webp'
    })?.[certSlug] || null
)

if (!location.value) {
  const event = useRequestEvent()
  if (event) setResponseStatus(event, 404, 'Certification not found.')
}

setWheelsCount(1)
</script>

<template lang="pug">
.cert__details
  .cert__details__iframe
    UIPdf(:endpoint="location", :preview="false", :scrolling="true")
</template>

<style lang="sass" scoped>
.cert__details
  @apply w-full h-[100dvh] flex-center
  .cert__details__iframe
    @apply w-10/12 h-[75vh] border-4 border-primary relative
</style>
